<template>
    <section>
			
        <Cloud />
        <header>
            <button @click="$router.go(-1)"></button>
            <h2 v-html="'More info'"></h2>
            <p>We will need some information to estimate the work is needed to complete your project. </p>
            <p>Would you like to fill our multistep form? If you are in arush you can always just drop us a message</p>
            
						<footer>
							<button 
								class="ryoma--default step ryoma--fat"
								@click="$router.push({name: 'step-2', params: { service:  $route.params.service}})">
									Go to the step by step form
							</button>
							<button 
								class="ryoma--default ryoma--outline ryoma--fat"
								@click="$router.push({name: 'step-2'})">
									Just fill essential info (3 steps)
								</button>
						</footer>
        </header>
    </section>
</template>

<script>
import Cloud from '@/components/origami/Cloud'

export default {
  name: 'step-1',
  components: {
    Cloud
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_mixins.scss';

section {
  position: relative;
  @include grid-padding;
  @include grid-container;
  text-align: center;
  padding-bottom: 25vh;
  height: 100vh;
  overflow-y: scroll;
  

  @include respond-to(desktop) {
    @include grid(12);
    text-align: left;
  }
  header {
    padding-top: 1vmin; 
    padding-bottom: $small-vmin; 
    grid-column: 2 / span 7;

    @include respond-to(tablet) {
      padding-top: 5vmin; 
    }
	}
	p,h2 {
		color: map-get($colors--grays, '2');
	}
	footer {
		@include respond-to(desktop) {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: $small_vmin;

			button {
				margin: $default_vmin 0 0;
			}
		}
	}
}
</style>